module.exports = __webpack_public_path__ + "img/1552658085.cfef5610.jpg";